import React from "react";
import { StyledContainer } from "../StyledComponents";
import AppBar from "../components/AppBar";
import { Typography } from "@material-ui/core";

export default function Tutorial() {

  return (
    <div>
      <AppBar title={"教學"} />
      <StyledContainer style={{ paddingTop: 90, paddingBottom: 80 }}>
        <Typography variant="h5" component="h2">
          教學
                </Typography>
      </StyledContainer>
      <AppBar title={"教學"} bottom={true} />
    </div>
  )
}